module.exports = {"150104001":"小召前街街道","150104002":"兴隆巷街道","150104003":"长和廊街道","150104004":"石东路街道","150104005":"大南街街道","150104006":"鄂尔多斯路街道","150104007":"西菜园街道","150104008":"昭君路街道","150104100":"小黑河镇","150104400":"裕隆工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150104.json
// module id = 481
// module chunks = 0